// @ts-ignore
import { findIn, on, removeAttribute } from "../../../dom-utils";
// @ts-ignore
import { getPrefixedDataSet } from "../../../data-set-utils";
import { renderTemplate } from "./utils";
export function createCookiebotOverlay(baseElement, options, selectors) {
    let data = getPrefixedDataSet(selectors.dataset, baseElement);
    let button = findIn(selectors.button, baseElement);
    // @ts-ignore
    if (Cookiebot.consent[data.service]) {
        renderTemplate(baseElement, { base: selectors.base, template: selectors.template });
    }
    else {
        if (baseElement.getAttribute('hidden')) {
            removeAttribute('hidden', baseElement);
        }
    }
    window.addEventListener(options.revalidateEvent, function () {
        // @ts-ignore
        if (Cookiebot.consent[data.service]) {
            renderTemplate(baseElement, { base: selectors.base, template: selectors.template });
        }
        else {
            if (baseElement.getAttribute('hidden')) {
                removeAttribute('hidden', baseElement);
            }
        }
    }, false);
    if (button) {
        on('click', () => {
            let consent = data.service;
            let preferences = consent === 'preferences';
            let statistics = consent === 'statistics';
            let marketing = consent === 'marketing';
            // @ts-ignore
            Cookiebot.submitCustomConsent(preferences, statistics, marketing);
        }, button);
    }
}
